/**
 * Calculate total amount invested based on number of shares and average amount per share
 * @param {number|string} numberOfShares - Total number of shares held
 * @param {number|string} averageAmountInvested - Average amount invested per share
 * @returns {number} Total amount invested
 */
export const calculateTotalAmountInvested = (numberOfShares, averageAmountInvested) => {
  const shares = parseFloat(numberOfShares) || 0;
  const average = parseFloat(averageAmountInvested) || 0;
  return shares * average;
};

/**
 * Calculate current value based on number of shares and last price
 * @param {number|string} numberOfShares - Total number of shares held
 * @param {number|string} lastPrice - Last price per share
 * @returns {number} Current value
 */
export const calculateCurrentValue = (numberOfShares, lastPrice) => {
  const shares = parseFloat(numberOfShares) || 0;
  const price = parseFloat(lastPrice) || 0;
  return shares * price;
};

/**
 * Calculate change (difference between current value and total invested)
 * @param {number} currentValue - Current value of investment
 * @param {number} totalAmountInvested - Total amount invested
 * @returns {number} Change amount
 */
export const calculateChange = (currentValue, totalAmountInvested) => {
  const current = parseFloat(currentValue) || 0;
  const invested = parseFloat(totalAmountInvested) || 0;
  return current - invested;
};

/**
 * Calculate change percentage
 * @param {number} change - Change amount
 * @param {number} totalAmountInvested - Total amount invested
 * @returns {number} Change percentage
 */
export const calculateChangePercentage = (change, totalAmountInvested) => {
  const changeAmount = parseFloat(change) || 0;
  const invested = parseFloat(totalAmountInvested) || 0;
  if (invested === 0) return 0;
  return (changeAmount / invested) * 100;
};

